import React from 'react';
import { DollarSign, Wallet, Search } from 'lucide-react';
import V4CeoDeptTemplate from './V4CeoDeptTemplate';
import { FINANCE_DEPT_DATA, FINANCE_DEPT_CHAT_RESPONSES } from '../../data/financeDeptData';
import { FINANCE_DEEP_DIVE, FINANCE_ALERT_DEEP_DIVES, FINANCE_DECISION_DEEP_DIVES, FINANCE_ROW_DEEP_DIVES } from '../../data/financeDeepDiveData';

const FinancialRow = ({ item, idx, isDark, onDeepDive }) => {
  const tp = isDark ? 'text-white' : 'text-slate-800';
  const ts = isDark ? 'text-white/50' : 'text-slate-500';
  const border = isDark ? 'border-white/[0.06]' : 'border-black/[0.06]';

  return (
    <div className={`flex items-center gap-3 px-3 py-2.5 rounded-lg border ${border} ${isDark ? 'bg-[#0d1b2a]' : 'bg-[#f0ece4]'}`} data-testid={`financial-${idx}`}>
      <Wallet className={`w-3.5 h-3.5 flex-shrink-0 ${isDark ? 'text-indigo-400' : 'text-indigo-600'}`} />
      <div className="flex-1 min-w-0">
        <p className={`text-[11px] font-semibold ${tp}`}>{item.label}</p>
        <p className={`text-[9px] mt-0.5 ${ts}`}>{item.detail}</p>
      </div>
      <button
        onClick={() => onDeepDive && onDeepDive(item)}
        className={`flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-medium transition-colors ${isDark ? 'bg-indigo-500/10 text-indigo-400 hover:bg-indigo-500/20' : 'bg-indigo-500/10 text-indigo-600 hover:bg-indigo-500/15'}`}
        data-testid={`financial-deep-dive-${idx}`}
      >
        <Search className="w-2.5 h-2.5" /> Deep Dive
      </button>
      <span className={`text-sm font-bold flex-shrink-0 ${tp}`}>{item.value}</span>
    </div>
  );
};

const V4FinanceDept = ({ isDark, onWorkflowToggle, workflowPanelOpen }) => (
  <V4CeoDeptTemplate
    isDark={isDark} onWorkflowToggle={onWorkflowToggle} workflowPanelOpen={workflowPanelOpen}
    data={FINANCE_DEPT_DATA} chatResponses={FINANCE_DEPT_CHAT_RESPONSES}
    deptIcon={DollarSign} deptLabel="Finance" deptColor={isDark ? 'text-emerald-400' : 'text-emerald-600'}
    agentId="finn" agentName="Finn" escalateLabel="Escalate to Neel" escalateTarget="Neel Gupta"
    col2Icon={Wallet} col2Label="Financial Overview" col2Items={FINANCE_DEPT_DATA.financials}
    col2Renderer={(item, i, dark, onDeepDive) => <FinancialRow key={i} item={item} idx={i} isDark={dark} onDeepDive={onDeepDive} />}
    testIdPrefix="finance-dept"
    deepDiveScript={FINANCE_DEEP_DIVE}
    alertDeepDives={FINANCE_ALERT_DEEP_DIVES}
    decisionDeepDives={FINANCE_DECISION_DEEP_DIVES}
    rowDeepDives={FINANCE_ROW_DEEP_DIVES}
    rowKeySelector={(item) => item.label}
  />
);

export default V4FinanceDept;
